module.exports = __webpack_public_path__ + "static/Guardianship-90435d012934d1cf4f4e86850696135c.mp4";